export default "__VITE_ASSET__DMQXmYiX__"